import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { IconButton } from "@material-ui/core";
import SettingsIcon from "@material-ui/icons/SettingsOutlined";
import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import CircularProgress from "@material-ui/core/CircularProgress";
import HelpOutlinedIcon from "@material-ui/icons/HelpOutline";
import StarOutlined from "@material-ui/icons/StarBorder";
import Tooltip from "../../common/StyledToolTip";
import styles from "../headerStyles";
import { trackEvent } from "../../common/AppInsightsEventTracking";
import { withAppConfig } from "../../../appConfigContext";
import { compose } from "recompose";
import Notifications from "./Notifications";
import NewShipmentsFeedbackPanel from "../../modules/IBPlanning/RoutesView/NewShipmentsFeedbackPanel";
class RightNavigationMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    if (this.props.width === "xl" || this.props.width === "lg") {
      this.props.closeMenu();
    }
  }

  handleHelpIconClick = (event) => {
    this.setState({ helpanchorEl: event.currentTarget });
  };

  handleHelpIconClose = () => {
    this.setState({ helpanchorEl: null });
  };

  openDynamicRoutingModal = () => {
    if (this.disbaleDynamicRouting || this.props.isOptimizationRunning) {
      return false;
    }
    this.props.shouldDialogOpen("dynamicRouting");
  };

  onHelpMenuItemClicked = (url, pageTitle) => {
    window.open(url, "_blank");
    this.handleHelpIconClose();
    this.props.closeMenu();

    const userProfile = this.props.userProfile;
    trackEvent("HelpMenu", userProfile, { pageTitle });
  };

  getOptimizationTooltip = (
    enableDynamicRouting,
    isDataRefreshProgress,
    selectedRouteCount
  ) => {
    if (!enableDynamicRouting) {
      return "Route optimization is disabled";
    }

    if (isDataRefreshProgress) {
      return "Data refresh is in progress";
    }

    if (selectedRouteCount) {
      return "Create most efficient routes without any zipcode boundaries";
    } else {
      return "Select at least one route to run dynamic routing";
    }
  };

  render() {
    const { helpanchorEl } = this.state;
    const {
      isOptimizationRunning,
      isDataRefreshProgress,
      isDefaultScenario,
      terminalCode,
      width,
      selectedRouteCount,
      enableDynamicRouting,
      classes,
      configJSON,
      handleAddClick,
      showNotificationHeaderIcon
    } = this.props;
    const { RMAXWhatsNewURL, RMAXHelpURL, terminalAccessLabel } = configJSON || {};
    this.disbaleDynamicRouting =
      !(enableDynamicRouting && selectedRouteCount) || isDataRefreshProgress;
    return (
      <div
        className={
          width === "xl" || width === "lg" ? "" : classes.mainMenuStyle
        }
      >
        <div
          className={`${classes.optymizeBtnContainer} ${classes.headerIconStyles}`}
        >
          <Tooltip
            title={this.getOptimizationTooltip(
              enableDynamicRouting,
              isDataRefreshProgress,
              selectedRouteCount
            )}
          >
            <div
              className={
                this.disbaleDynamicRouting ? classes.disabledCursor : ""
              }
            >
              <Button
                onClick={this.openDynamicRoutingModal}
                variant="contained"
                color="primary"
                size="small"
                disabled={this.disbaleDynamicRouting}
                classes={{
                  root: classes.optymizeButtonStyle,
                  disabled: classes.disabledOptymizeBtn,
                }}
                data-automationid="optimize-button"
              >
                {isOptimizationRunning ? (
                  <CircularProgress size={16} color="inherit" />
                ) : (
                  "Route Optymizer"
                )}
              </Button>
            </div>
          </Tooltip>
        </div>
        <div
          className={`${classes.muiIconContainer} ${classes.headerIconStyles}`}
          data-automationid="help-menu"
        >
          <IconButton
            color="inherit"
            className={classes.muiIconButtonStyle}
            onClick={this.handleHelpIconClick}
          >
            <Tooltip title="Help">
              <HelpOutlinedIcon />
            </Tooltip>
          </IconButton>
          <Menu
            getContentAnchorEl={null}
            disableAutoFocusItem={true}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            open={Boolean(helpanchorEl)}
            anchorEl={helpanchorEl}
            onClose={this.handleHelpIconClose}
            MenuListProps={{ disablePadding: true }}
            classes={{
              paper: classes.helpMenu,
            }}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          >
            {RMAXHelpURL && (
              <MenuItem
                className={`${classes.helpMenuItem} ${classes.disableHelpMenuHover}`}
                onClick={() => this.onHelpMenuItemClicked(RMAXHelpURL, "Help")}
                data-automationid="help"
              >
                <IconButton
                  disableRipple={true}
                  color="primary"
                  className={classes.disableHelpMenuHover}
                >
                  <HelpOutlinedIcon />
                </IconButton>
                Help
              </MenuItem>
            )}

            {RMAXWhatsNewURL && (
              <MenuItem
                className={`${classes.helpMenuItem} ${classes.disableHelpMenuHover}`}
                onClick={() =>
                  this.onHelpMenuItemClicked(RMAXWhatsNewURL, "What's New")
                }
                data-automationid="whats-new"
              >
                <IconButton
                  disableRipple={true}
                  className={`${classes.starIconColor} ${classes.disableHelpMenuHover}`}
                >
                  <StarOutlined />
                </IconButton>
                What's New
              </MenuItem>
            )}

            <MenuItem
              className={`${classes.helpMenuItem} ${classes.disableHelpMenuHover}`}
              onClick={() => {
                this.props.shouldDialogOpen("aboutRMAX");
                this.handleHelpIconClose();
                this.props.closeMenu();
              }}
              data-automationid="about-rmax"
            >
              <IconButton
                disableRipple={true}
                className={classes.disableHelpMenuHover}
              >
                <img src="../../images/AboutRMAX.svg" />
              </IconButton>
              About RouteMAX
            </MenuItem>
          </Menu>
        </div>
        <div
          className={`${classes.terminalIconStyle} ${classes.headerIconStyles}`}
          onClick={this.props.handleTerminalClick}
          data-automationid="terminal-access"
        >
          <Tooltip title={terminalAccessLabel.menuLabel}>
            <span>
              {terminalCode}
              <i
                className="icon-down-dir"
                onClick={this.props.handleTerminalClick}
              />
            </span>
          </Tooltip>
        </div>
        <div
          className={`${classes.publishIconContainer} ${classes.headerIconStyles}`}
          onClick={() => {
            this.props.shouldDialogOpen("publish", Boolean(isDefaultScenario));
            this.props.closeMenu();
          }}
          data-automationid="publish-routes"
        >
          <Tooltip
            title={
              isDefaultScenario
                ? "Publish Routes"
                : "Can only publish routes from default scenario"
            }
          >
            <i
              className={`${
                isDefaultScenario
                  ? classes.publishIconStyle
                  : classes.disabledPublishIcon
              } icon-icon_upload`}
            />
          </Tooltip>
        </div>
        <div
          className={`${classes.muiIconContainer} ${classes.headerIconStyles}`}
        >
          <IconButton
            color="inherit"
            className={classes.muiIconButtonStyle}
            onClick={(e) => {
              this.props.openSettings(e, "/settings");
              this.props.closeMenu();
            }}
            data-automationid="settings-icon"
          >
            <Tooltip title="Application Settings">
              <SettingsIcon />
            </Tooltip>
          </IconButton>
        </div>
        {showNotificationHeaderIcon && (
          <Notifications //TODO : Reuse this component for showing driver msgs in dispatch module by just passing a different component as children prop.
            toggleNotificationPanel={this.props.toggleNotificationPanel}
            showNotificationPanel={this.props.showNotificationPanel}
            showNewNotification={this.props.showNewShipmentsNotification}
            unreadCount={this.props.unreadCount}
          >
            <NewShipmentsFeedbackPanel
              handleAddClick={handleAddClick}
              hideCloseAction
              hidePanelShadow
            />
          </Notifications>
        )}
        {/* <div className={`${classes.muiIconContainer} ${classes.headerIconStyles}`}>
                                <Tooltip title="Notifications">
                                    <IconButton color="inherit" className={classes.muiIconButtonStyle}>
                                        <NotificationsIcon />
                                    </IconButton>
                                </Tooltip>
                            </div> */}
      </div>
    );
  }
}

export default compose(withStyles(styles), withAppConfig)(RightNavigationMenu);
